import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable()
export class RejeitadosReceitaFederalService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getData(regans: string, competenciaInicial: string, competenciaFinal: string) {
    return this.simuladorGoApi.fetchRejeitadosReceitaFederal({
      regans,
      competencia: competenciaInicial,
      competencia_final: competenciaFinal,
    }).pipe(map(data => data.items));
  }

  getDataFornecimento(regans: string, competenciaInicial: string, competenciaFinal: string) {
    return this.simuladorGoApi.fetchRejeitadosReceitaFederalFornecimento({
      regans,
      competencia: competenciaInicial,
      competencia_final: competenciaFinal,
    }).pipe(map(data => data.items));
  }

  getListagemLancamentos(
    regans: string,
    competenciaInicial: string,
    dt_nascimento: string | number,
    id_sexo: number,
    hash_cpf_cns: number,
  ) {
    return this.simuladorGoApi.fetchLancamentosRejeitadosReceitaFederal({
      regans,
      competencia: competenciaInicial,
      competencia_final: competenciaInicial,
      dt_nascimento,
      id_sexo,
      hash_cpf_cns,
    }).pipe(map(data => data.items));
  }

  getListagemLancamentosFornecimento(
    regans: string,
    competenciaInicial: string,
    dt_nascimento: string | number,
    id_sexo: number,
    hash_cpf_cns: number,
  ) {
    return this.simuladorGoApi.fetchLancamentosRejeitadosReceitaFederalFornecimento({
      regans,
      competencia: competenciaInicial,
      competencia_final: competenciaInicial,
      dt_nascimento,
      id_sexo,
      hash_cpf_cns,
    }).pipe(map(data => data.items));
  }
}
